import React, { Component } from 'react';
import whyitmattersdata from '../../../data/whyitmatterscard';

class WhyItMattersCard extends Component {

  render() {
    return (
        <div className="why-flex">
            {
            whyitmattersdata.map(function(why){
              return <div key={why.id}>
                <div className="why-contianer">
                    <h4>{why.copy}</h4>
                </div>
              </div>;
            })
          }
        </div>
        
    );
  }
}

export default WhyItMattersCard;


// WEBPACK FOOTER //
// ./src/components/whyitmatters/whyitmatterscards/whyitmatterscards.js